import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Table from 'components/Shared/Table'
import { ErrorDialog } from 'components/Shared/Dialogs/ErrorDialog'
import { RelatedOrdersErrorMessage } from 'components/Shared/Dialogs/DialogContents'
import { deleteUser, fetchUsersPage } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { HTTP_404_ERROR } from 'Constants'
import { columns } from 'components/Users/columns'
import { useAuth, USER_CREATE, USER_DELETE, USER_EDIT } from 'context/auth'

export function UsersTable () {
  let history = useHistory()

  const { handleError } = useErrorHandling()

  const [relatedOrdersErrors, setRelatedOrdersErrors] = useState([])

  const { username: currentUserUsername, hasAnyPrivileges } = useAuth()

  const addUser = () => {
    history.push('/users/create')
  }

  const details = (row) => {
    history.push('/users/details/' + row.id)
  }

  const editUser = (row) => {
    history.push('/users/edit/' + row.id)
  }

  const onDeleteError = (error) => {
    if (error?.response?.data?.data?.ordersId) {
      setRelatedOrdersErrors(error.response.data.data.ordersId)
    } else {
      handleError(error, {
        [HTTP_404_ERROR]: 'notifications.error.delete'
      }).then(() => setRelatedOrdersErrors([]))
    }
  }

  const isUserDeletable = user => user.username !== currentUserUsername && hasAnyPrivileges([USER_DELETE])

  const addButton = {
    label: 'userTable.addButtonLabel',
    onClick: addUser,
    isClickable: hasAnyPrivileges([USER_CREATE])
  }

  const menuOptions = {
    edit: {
      onClick: editUser,
      isEditable: () => hasAnyPrivileges([USER_EDIT])
    },
    delete: {
      onDelete: deleteUser,
      onDeleteError: onDeleteError,
      isDeletable: isUserDeletable,
      deleteDialog: {
        content: 'userTable.deleteDialog.content',
        title: 'userTable.deleteDialog.title'
      }
    }
  }

  return (
    <>
      <Table title={'userTable.title'}
             addButton={addButton}
             fetchData={fetchUsersPage}
             columns={columns}
             tableKey={'users'}
             onRowClick={details}
             menu={menuOptions}/>
      <ErrorDialog
        open={!!relatedOrdersErrors && relatedOrdersErrors.length > 0}
        onClose={() => {
          setRelatedOrdersErrors([])
        }}
        content={<RelatedOrdersErrorMessage idList={relatedOrdersErrors}/>}/>
    </>
  )
}
